export default "__VITE_ASSET__B3h2MCRu__"